import React from "react";

export const MailClosedIcon = ({ size = 14, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		{...rest}>
		<rect
			x="1.5"
			y="3.25"
			width="11"
			height="8.25"
			rx="1.2"
			stroke="currentColor"
			strokeWidth="1.1"
		/>
		<path
			d="M1.5 4.5L7 8.25L12.5 4.5"
			stroke="currentColor"
			strokeWidth="1.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const MailOpenIcon = ({ size = 14, ...rest }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		{...rest}>
		<path
			d="M1.5 5.25L7 9.5L12.5 5.25"
			stroke="currentColor"
			strokeWidth="1.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.5 4.75L7 1.75L12.5 4.75"
			stroke="currentColor"
			strokeWidth="1.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.5 5.25V10.75C1.5 11.35 2 11.85 2.6 11.85H11.4C12 11.85 12.5 11.35 12.5 10.75V5.25"
			stroke="currentColor"
			strokeWidth="1.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
